import React from "react";
import GoogleOAuthSettings from "./GoogleOAuthSettings";
import "./AdminIntegrations.css";

const AdminIntegrations = () => <GoogleOAuthSettings />;

export default AdminIntegrations;
